import { IUserService } from "../services/UserService";
import { IOrganizationService } from "../services/Organization/OrganizationService";

// Module-scoped persistent cache
const cache = new Map<string, any>();

export async function getUserHomeOrganizationDetails({
    email,
    organizationService,
    userService
}: {
    email: string;
    organizationService: IOrganizationService;
    userService: IUserService;
}) {
    const userDetails = await userService.getUserByEmail(email, true).catch((e) => {
        if (e?.message?.match(/.*404.*/)) {
            throw new Error(`No user found for email: ${email}`);
        }
        throw e;
    });

    const { homeOrganizationId } = userDetails;
    if (!homeOrganizationId) {
        throw new Error(`User does not have a home organization`);
    }

    // cache based on email & home org since the home org can be changed, don't want to pre-emptively cache.
    const cacheKey = `${email}-${homeOrganizationId}`;

    const cached = cache.get(cacheKey);
    if (cached) {
        return cached;
    }

    const orgDetails = await organizationService.getOrganization({ id: homeOrganizationId });
    const details = { user: userDetails, organization: orgDetails };

    if (orgDetails) {
        cache.set(cacheKey, details);
    }

    return details;
}
